import api from "../../api";
import { transationByUserEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  GET_USERS_TRANSACTIONS_FAILD,
  GET_USERS_TRANSACTIONS_LOADING,
  GET_USERS_TRANSACTIONS_SUCCESS,
  REMOVE_USERS_TRANSACTIONS,
} from "../types";

 export const getTransactionsByUserId = (token: any, id: any) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      error?: any;
    }) => void
  ) => {
    dispatch({ type: GET_USERS_TRANSACTIONS_LOADING, loading: true });
    await api.get(transationByUserEndpoint(id), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch({ type: GET_USERS_TRANSACTIONS_LOADING, loading: false });
        dispatch({ type: GET_USERS_TRANSACTIONS_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        apiError(
          GET_USERS_TRANSACTIONS_LOADING,
          GET_USERS_TRANSACTIONS_FAILD,
          err,
          dispatch
        );
      });
  };
}; 


export const getTransactionsByUserId2 = async(token: any, id: any) => {

  return  await api.get(transationByUserEndpoint(id), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((res)=>{
    return res.data; 
  })

}

export const RemoveUserTransactions=()=>{
  return{
    type:REMOVE_USERS_TRANSACTIONS
  }
}